import parsePhoneNumberFromString, { isValidPhoneNumber, validatePhoneNumberLength } from 'libphonenumber-js/max'

import yup from '~/utils/validationMessages'

import { errors } from './errors'

type LoginField = {
  title: string
  name: 'email' | 'password'
  type: string
}

export const LOGIN_FORM_FIELDS: LoginField[] = [
  {
    title: 'Email',
    name: 'email',
    type: 'email',
  },
  {
    title: 'Password',
    name: 'password',
    type: 'password',
  },
]

export const validationFields = {
  email: yup.string().email().required(),
  firstName: yup.string().max(100).required(),
  lastName: yup.string().max(100).required(),
  password: yup.string().required(),

  phoneNumber: yup.string().test('phoneNumber', errors.validation.phone_number.invalid, (value, ctx) => {
    if (!value) return true

    const { createError, path } = ctx

    const numberForLibphone = value
    const parsedNumber = parsePhoneNumberFromString(numberForLibphone)
    const phoneNumber = parsedNumber?.number || value

    const validationError = validatePhoneNumberLength(phoneNumber)

    if (validationError === 'TOO_LONG') return createError({ message: errors.validation.phone_number.too_long, path })

    if (validationError === 'TOO_SHORT') return createError({ message: errors.validation.phone_number.too_short, path })

    const isValid = isValidPhoneNumber(phoneNumber)

    if (!isValid) {
      return createError({ message: errors.validation.phone_number.invalid, path })
    }
    return true
  }),
  city: yup
    .string()
    .matches(/^[A-Za-zĄĆĘŁŃÓŚŹŻąćęłńóśźż]+$/, errors.validation.mixed.letters_only)
    .required(),
}

export const loginSchema = yup.object().shape({
  email: validationFields.email,
  password: validationFields.password,
})
